import { createSelector } from 'reselect'
import { initialState } from './reducer'

const select2fa = (state) => state.setting2fa || initialState

const makeSelect2fa = () => createSelector(
  select2fa,
  (state) => state
)

export {
  select2fa,
  makeSelect2fa
}
